import { Helmet } from "react-helmet-async";
import { Building2, Users, BarChart3, Shield, Headphones, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import { Button } from "@/components/ui/button";
const Empresas = () => {
  const benefits = [
    {
      icon: Users,
      title: "Engajamento de Equipes",
      description: "Crie desafios entre departamentos e aumente a motivação coletiva.",
    },
    {
      icon: BarChart3,
      title: "Métricas de Bem-estar",
      description: "Acompanhe indicadores de saúde e produtividade da sua equipe.",
    },
    {
      icon: Shield,
      title: "Dados Seguros",
      description: "Privacidade garantida com criptografia e conformidade LGPD.",
    },
    {
      icon: Headphones,
      title: "Suporte Dedicado",
      description: "Gerente de conta exclusivo e onboarding personalizado.",
    },
    {
      icon: Building2,
      title: "Integração com RH",
      description: "Conecte com suas ferramentas de gestão de pessoas.",
    },
    {
      icon: Zap,
      title: "Resultados Rápidos",
      description: "Veja mudanças positivas na cultura em poucas semanas.",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>HabitFrog para Empresas | Gamificação de Hábitos Corporativos</title>
        <meta name="description" content="Transforme a cultura da sua empresa com gamificação de hábitos saudáveis. Aumente engajamento, reduza turnover e melhore o bem-estar dos colaboradores." />
        <link rel="canonical" href="https://habitfrog.com/empresas" />
      </Helmet>

      <Header />
      <ScrollToTopButton />

      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <header className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-block bg-primary/20 text-primary px-4 py-2 rounded-full text-sm font-semibold mb-4">
              Para Empresas
            </span>
            <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6">
              Transforme a Cultura da Sua Empresa
            </h1>
            <p className="text-xl text-muted-foreground mb-8">
              Use gamificação para criar hábitos saudáveis em equipe. Aumente produtividade, reduza absenteísmo e construa um ambiente de trabalho mais feliz.
            </p>
            <Button size="lg" asChild>
              <Link to="/auth">Solicitar Demonstração</Link>
            </Button>
          </header>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto mb-16">
            {benefits.map((benefit) => (
              <div key={benefit.title} className="bg-card rounded-xl p-6 border">
                <benefit.icon className="w-10 h-10 text-primary mb-4" />
                <h3 className="text-xl font-bold text-foreground mb-2">{benefit.title}</h3>
                <p className="text-muted-foreground">{benefit.description}</p>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-2xl p-8 md:p-12 text-center max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
              Pronto para transformar sua empresa?
            </h2>
            <p className="text-muted-foreground mb-6">
              Agende uma demonstração gratuita e descubra como o HabitFrog pode ajudar sua equipe.
            </p>
            <Button size="lg" asChild>
              <Link to="/auth">Falar com Especialista</Link>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Empresas;
